export const VERSION = {
  PROD: 'V. 3.3.2',
  QA: 'V. 4.1.5 (QA)',
}
